<template>
    <div class="virtual-games__item">
        <div
            class="virtual-games__item-wrapper"
            @click="$emit('click', false)"
        >
            <img class="virtual-games__item-image" :src="imageUrl"/>
            <div class="games__item-badges">
                <span
                    v-if="isLive"
                    class="games__item-badge games__item-badge--live"
                >
                    {{ $t('live') | capitalize }}
                </span>
                <span
                    v-if="isNew"
                    class="games__item-badge games__item-badge--new"
                >
                    {{ $t('new') | capitalize }}
                </span>
            </div>

            <div class="virtual-games__item-betting-range-wrapper">
                <span class="virtual-games__item-betting-range">{{ bettingRange }}</span>
            </div>
            <div class="virtual-games__item-overlay">
                <div class="virtual-games__item-details">
                    <SanitizedHtml
                        :content="name"
                        class="virtual-games__item-title"
                    >
                    </SanitizedHtml>
                    <span class="virtual-games__item-subtitle">
                        {{ description | capitalize }}
                    </span>
                    <button
                        @click="$emit('click', false)"
                        class="btn btn--md btn--w-144 btn__primary--yellow virtual-games__item-play"
                    >
                        {{ $t('play') | capitalize }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '@config';
    import SanitizedHtml from '@modules/shared/components/SanitizedHtml.vue';

    export default {
        name: 'VirtualGame',
        props: {
            externalId: {
                type: Number,
                required: false,
            },
            imageSrc: {
                type: String,
                required: false,
                default: ''
            },
            name: {
                type: String,
                required: false,
                default: ''
            },
            isNew: {
                type: Boolean,
                default: false
            },
            isJackpot: {
                type: Boolean,
                default: false
            },
            hasDemo: {
                type: Boolean,
                default: false
            },
            isLive: {
                type: Boolean,
                default: false,
            },
            bettingRange: {
                type: String,
                default: '',
            },
            isFavourable: {
                type: Boolean,
                default: false,
            },
            isFavourite: {
                type: Boolean,
                default: false,
            },
            description: {
                type: String,
                required: true,
            },
        },
        computed: {
            imageUrl() {
                return `${config.services.casino.host}${this.imageSrc}`;
            },
        },
        components: {
            SanitizedHtml,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/games/shared/components/VirtualGame.vue